/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetMember,
  FleetMemberCreateInput,
  FleetMemberHealth,
  FleetMemberHealthParams,
  FleetMemberUpdateInput,
  FleetMembersList,
  FleetMembersParams,
  SchemaValidationErrorResponse,
  StandardError,
  StandardMessage,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Member Health
 */
export const fleetMemberHealth = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMemberHealthParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetMemberHealth>(
      {url: `/fleets/${fleetSlug}/member-health`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetMemberHealthQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMemberHealthParams>,) => {
    return [
    'fleets',fleetSlug,'member-health', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetMemberHealthQueryOptions = <TData = Awaited<ReturnType<typeof fleetMemberHealth>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMemberHealthParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMemberHealth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMemberHealthQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMemberHealth>>> = ({ signal }) => fleetMemberHealth(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMemberHealth>>, TError, TData>
}

export type FleetMemberHealthQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMemberHealth>>>
export type FleetMemberHealthQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Member Health
 */

export function useFleetMemberHealth<TData = Awaited<ReturnType<typeof fleetMemberHealth>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMemberHealthParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMemberHealth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMemberHealthQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Member
 */
export const createFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetMemberCreateInput: MaybeRefOrGetter<FleetMemberCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetMemberCreateInput = toValue(fleetMemberCreateInput);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetMemberCreateInput, signal
    },
      );
    }




export const getCreateFleetMemberMutationKey = () => ['createFleetMember'] as const;

export const getCreateFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetMember>>, TError,CreateFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetMember>>, TError,CreateFleetMemberMutationVariables, TContext> => {

const mutationKey = getCreateFleetMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetMember>>, CreateFleetMemberMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetMember(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetMember>>>
    export type CreateFleetMemberMutationBody = FleetMemberCreateInput
    export type CreateFleetMemberMutationError = ErrorType<ValidationError | StandardError>
    export type CreateFleetMemberMutationVariables = {fleetSlug: string;data: FleetMemberCreateInput}

    /**
 * @summary Create Member
 */
export const useCreateFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetMember>>, TError,CreateFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetMember>>,
        TError,
        CreateFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Fleet Member List
 */
export const fleetMembers = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetMembersList>(
      {url: `/fleets/${fleetSlug}/members`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetMembersQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>,) => {
    return [
    'fleets',fleetSlug,'members', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetMembersQueryOptions = <TData = Awaited<ReturnType<typeof fleetMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMembersQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMembers>>> = ({ signal }) => fleetMembers(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>
}

export type FleetMembersQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMembers>>>
export type FleetMembersQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Member List
 */

export function useFleetMembers<TData = Awaited<ReturnType<typeof fleetMembers>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMembersParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMembers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMembersQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Remove Fleet Member
 */
export const destroyFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/members/${username}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetMemberMutationKey = () => ['destroyFleetMember'] as const;

export const getDestroyFleetMemberMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMember>>, TError,DestroyFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMember>>, TError,DestroyFleetMemberMutationVariables, TContext> => {

const mutationKey = getDestroyFleetMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetMember>>, DestroyFleetMemberMutationVariables> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  destroyFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetMember>>>

    export type DestroyFleetMemberMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetMemberMutationVariables = {fleetSlug: string;username: string}

    /**
 * @summary Remove Fleet Member
 */
export const useDestroyFleetMember = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMember>>, TError,DestroyFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetMember>>,
        TError,
        DestroyFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * A single membership, so a notification about it can show what state it is in now
 * @summary Show Member
 */
export const fleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members/${username}`, method: 'GET', signal
    },
      );
    }




export const getFleetMemberQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'members',username
    ] as const;
    }


export const getFleetMemberQueryOptions = <TData = Awaited<ReturnType<typeof fleetMember>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMember>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMemberQueryKey(fleetSlug,username);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMember>>> = ({ signal }) => fleetMember(fleetSlug,username, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(username) !== null && toValue(username) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMember>>, TError, TData>
}

export type FleetMemberQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMember>>>
export type FleetMemberQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Member
 */

export function useFleetMember<TData = Awaited<ReturnType<typeof fleetMember>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMember>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMemberQueryOptions(fleetSlug,username,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * Set the nickname a fleet knows a member by
 * @summary Update Member
 */
export const updateFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
    fleetMemberUpdateInput: MaybeRefOrGetter<FleetMemberUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);
fleetMemberUpdateInput = toValue(fleetMemberUpdateInput);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members/${username}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetMemberUpdateInput, signal
    },
      );
    }




export const getUpdateFleetMemberMutationKey = () => ['updateFleetMember'] as const;

export const getUpdateFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMember>>, TError,UpdateFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetMember>>, TError,UpdateFleetMemberMutationVariables, TContext> => {

const mutationKey = getUpdateFleetMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetMember>>, UpdateFleetMemberMutationVariables> = (props) => {
          const {fleetSlug,username,data} = props ?? {};

          return  updateFleetMember(fleetSlug,username,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetMember>>>
    export type UpdateFleetMemberMutationBody = FleetMemberUpdateInput
    export type UpdateFleetMemberMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateFleetMemberMutationVariables = {fleetSlug: string;username: string;data: FleetMemberUpdateInput}

    /**
 * @summary Update Member
 */
export const useUpdateFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMember>>, TError,UpdateFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetMember>>,
        TError,
        UpdateFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * @summary Accept Member
 */
export const acceptFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<StandardMessage>(
      {url: `/fleets/${fleetSlug}/members/${username}/accept`, method: 'PUT', signal
    },
      );
    }




export const getAcceptFleetMemberMutationKey = () => ['acceptFleetMember'] as const;

export const getAcceptFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMember>>, TError,AcceptFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMember>>, TError,AcceptFleetMemberMutationVariables, TContext> => {

const mutationKey = getAcceptFleetMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptFleetMember>>, AcceptFleetMemberMutationVariables> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  acceptFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof acceptFleetMember>>>

    export type AcceptFleetMemberMutationError = ErrorType<ValidationError | StandardError>
    export type AcceptFleetMemberMutationVariables = {fleetSlug: string;username: string}

    /**
 * @summary Accept Member
 */
export const useAcceptFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptFleetMember>>, TError,AcceptFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof acceptFleetMember>>,
        TError,
        AcceptFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getAcceptFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * No Member found
 * @summary Decline Member
 */
export const declineFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<StandardMessage>(
      {url: `/fleets/${fleetSlug}/members/${username}/decline`, method: 'PUT', signal
    },
      );
    }




export const getDeclineFleetMemberMutationKey = () => ['declineFleetMember'] as const;

export const getDeclineFleetMemberMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetMember>>, TError,DeclineFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof declineFleetMember>>, TError,DeclineFleetMemberMutationVariables, TContext> => {

const mutationKey = getDeclineFleetMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof declineFleetMember>>, DeclineFleetMemberMutationVariables> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  declineFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeclineFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof declineFleetMember>>>

    export type DeclineFleetMemberMutationError = ErrorType<ValidationError | StandardError>
    export type DeclineFleetMemberMutationVariables = {fleetSlug: string;username: string}

    /**
 * @summary Decline Member
 */
export const useDeclineFleetMember = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof declineFleetMember>>, TError,DeclineFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof declineFleetMember>>,
        TError,
        DeclineFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getDeclineFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * No Member found
 * @summary Demote Member
 */
export const demoteFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members/${username}/demote`, method: 'PUT', signal
    },
      );
    }




export const getDemoteFleetMemberMutationKey = () => ['demoteFleetMember'] as const;

export const getDemoteFleetMemberMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof demoteFleetMember>>, TError,DemoteFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof demoteFleetMember>>, TError,DemoteFleetMemberMutationVariables, TContext> => {

const mutationKey = getDemoteFleetMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof demoteFleetMember>>, DemoteFleetMemberMutationVariables> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  demoteFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DemoteFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof demoteFleetMember>>>

    export type DemoteFleetMemberMutationError = ErrorType<StandardError>
    export type DemoteFleetMemberMutationVariables = {fleetSlug: string;username: string}

    /**
 * @summary Demote Member
 */
export const useDemoteFleetMember = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof demoteFleetMember>>, TError,DemoteFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof demoteFleetMember>>,
        TError,
        DemoteFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getDemoteFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * No Member found
 * @summary Promote Member
 */
export const promoteFleetMember = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<FleetMember>(
      {url: `/fleets/${fleetSlug}/members/${username}/promote`, method: 'PUT', signal
    },
      );
    }




export const getPromoteFleetMemberMutationKey = () => ['promoteFleetMember'] as const;

export const getPromoteFleetMemberMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteFleetMember>>, TError,PromoteFleetMemberMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof promoteFleetMember>>, TError,PromoteFleetMemberMutationVariables, TContext> => {

const mutationKey = getPromoteFleetMemberMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof promoteFleetMember>>, PromoteFleetMemberMutationVariables> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  promoteFleetMember(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PromoteFleetMemberMutationResult = NonNullable<Awaited<ReturnType<typeof promoteFleetMember>>>

    export type PromoteFleetMemberMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type PromoteFleetMemberMutationVariables = {fleetSlug: string;username: string}

    /**
 * @summary Promote Member
 */
export const usePromoteFleetMember = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof promoteFleetMember>>, TError,PromoteFleetMemberMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof promoteFleetMember>>,
        TError,
        PromoteFleetMemberMutationVariables,
        TContext
      > => {
      return useMutation(getPromoteFleetMemberMutationOptions(options), queryClient);
    }
    /**
 * Notifies the member what keeps them from being verified against the fleet's RSI org. Once a week at most.
 * @summary Remind Member to Verify
 */
export const remindFleetMemberVerification = (
    fleetSlug: MaybeRefOrGetter<string>,
    username: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
username = toValue(username);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/members/${username}/verification-reminder`, method: 'POST', signal
    },
      );
    }




export const getRemindFleetMemberVerificationMutationKey = () => ['remindFleetMemberVerification'] as const;

export const getRemindFleetMemberVerificationMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindFleetMemberVerification>>, TError,RemindFleetMemberVerificationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof remindFleetMemberVerification>>, TError,RemindFleetMemberVerificationMutationVariables, TContext> => {

const mutationKey = getRemindFleetMemberVerificationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof remindFleetMemberVerification>>, RemindFleetMemberVerificationMutationVariables> = (props) => {
          const {fleetSlug,username} = props ?? {};

          return  remindFleetMemberVerification(fleetSlug,username,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemindFleetMemberVerificationMutationResult = NonNullable<Awaited<ReturnType<typeof remindFleetMemberVerification>>>

    export type RemindFleetMemberVerificationMutationError = ErrorType<ValidationError | StandardError>
    export type RemindFleetMemberVerificationMutationVariables = {fleetSlug: string;username: string}

    /**
 * @summary Remind Member to Verify
 */
export const useRemindFleetMemberVerification = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof remindFleetMemberVerification>>, TError,RemindFleetMemberVerificationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof remindFleetMemberVerification>>,
        TError,
        RemindFleetMemberVerificationMutationVariables,
        TContext
      > => {
      return useMutation(getRemindFleetMemberVerificationMutationOptions(options), queryClient);
    }
